import React from "react";
import Navbar from "../../Componect/Navbar/Navbar";
import FooterBottom from "../../Componect/Footer/FooterBottom";
import '../About/About.css';
function About() {
    return (
        <>
        <div className="About">
            <Navbar></Navbar>
            <div className="AboutTxt">
                <h1>"স তে সতেরো"</h1>
                <p>"স তে সতেরো" is a restaurant located in Uttara, Dhaka, Bangladesh, offering a variety of dishes in a pleasant environment suitable for family and friends. The establishment is situated near the Uttara Center Metro Rail Station, opposite Metro Rail Pillar No. 78.</p>
                <ul>
                    <li>Instagram</li>
                    <li>Contact Information:
                        <ul>
                            <li>Phone: 01780-126370​</li>
                            <li>Address: Sector 17, Block I, Road 10, Plot 26, Uttara, Dhaka ​</li>
                        </ul>
                    </li>
                    <li>Operating Hours: Every day from 11:00 AM to 11:00 PM. ​</li>
                    <li>Website: <a href="https://s-te-sotero.netlify.app/">https://s-te-sotero.netlify.app/</a></li>
                    <li>Menu Highlights: The restaurant offers a diverse menu, including fast food, lunch, and dinner options. They also provide catering services for various events. ​</li>
                    <li>Special Offers: During festive seasons, "স তে সতেরো" introduces special menus and offers. For instance, they have an Eid special menu, and orders are accepted up to a specific date before the festival. ​</li>
                    <li>Ambiance: The restaurant features a forest-themed interior, providing a unique and aesthetic dining experience. ​</li>
                    <li>Online Presence: For more information, updates, and promotions, you can visit their official website or follow their social media pages.​</li>
                    <li>Delivery Services: "স তে সতেরো" offers delivery services through platforms like Foodpanda, allowing customers to enjoy their meals at home. ​</li>
                    <li>Customer Reviews: Patrons have appreciated the restaurant for its budget-friendly and delicious food options, as well as its inviting ambiance. ​</li>
                </ul>
                <p>For the latest updates and offers, consider visiting their social media pages or contacting them directly.</p>
            </div>
            <FooterBottom></FooterBottom>
        </div>
        </>
    );
}
export default About;